<template>
  <div>
    <b-card no-body>
      <div class="card-padding">
        <div
          class="header-menu-wrapper d-block d-md-flex justify-content-between"
        >
          <div class="left-menu-group d-flex align-items-center">
            <span class="header__label">Escalation Template</span>
          </div>
          <div
            class="right-menu-group d-md-flex justify-content-end mt-1 mt-md-0"
          >
            <atom-button
              v-if="hasUpdateTicketEscalationPermission"
              buttonId="create-new-template"
              class="header__button"
              buttonStyle="border"
              @click="goToCreateTemplate"
            >
              <span> New Template </span>
            </atom-button>
          </div>
        </div>
        <div class="filter-wrapper mt-2">
          <div class="row">
            <div class="col-12 col-md-6">
              <atom-input
                v-model="filterList.templateName"
                title="Template Name"
                placeholder="Template Name"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
            <div class="col-12 col-md-6 mt-1 mt-md-0">
              <atom-input
                v-model="filterList.description"
                title="Description"
                placeholder="Description"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12 col-md-6">
              <atom-multi-select
                v-model="filterList.status"
                title="Status"
                placeholder="All Status"
                label="name"
                :isEnableProper="false"
                :isAppendToBody="false"
                :option="templateStatusOption"
              ></atom-multi-select>
            </div>
            <div
              class="col-12 col-md-6 mt-1 mt-md-0 d-flex align-items-end justify-content-end justify-content-md-start"
            >
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mt-1">
        <div class="col-12 table-wrapper">
          <b-table
            sticky-header
            responsive
            hover
            :items="items"
            :fields="fields"
            @row-clicked="selectRow"
            show-empty
          >
            <template #head(ticketAmount)="data">
              <div class="d-flex custom-padding-left-10px">
                {{ data.label }}
              </div>
              <div class="d-flex">(IN PROGRESS/ALL)</div>
            </template>
            <template #cell(status)="data">
              <div>
                <b-badge
                  pill
                  :variant="badgeVariant(data.item.status)"
                  class="badge--width font-9px"
                  >{{ badgeStatus(data.item.status) }}
                </b-badge>
              </div>
            </template>
            <template #cell(templateName)="data">
              <div class="custom-template-name-wrapper">
                <span class="text-medium-black">{{ data.value }}</span>
              </div>
            </template>
            <template #cell(description)="data">
              <div class="custom-description-wrapper">
                {{ data.value }}
              </div>
            </template>
            <template #cell(ticketAmount)="data">
              <div class="d-flex">
                <span
                  :class="{
                    'text-semibold-black':
                      Number(data.item.ticketAmount.inProgress) > 0,
                  }"
                >
                  In Progress: {{ data.item.ticketAmount.inProgress }}
                </span>
              </div>
              <div>
                <span> All: {{ data.item.ticketAmount.all }} </span>
              </div>
            </template>
            <template
              v-if="hasDeleteTicketEscalationPermission"
              #cell(deleteAction)="data"
            >
              <atom-button
                buttonId="button-delete"
                iconLeft="Trash2Icon"
                buttonStyle="flat"
                buttonColor="secondary"
                :isDisable="Number(data.item.ticketAmount.inProgress) > 0"
                @click="clickDeleteTemplate(data)"
              ></atom-button>
            </template>
            <template #empty>
              <div
                class="d-flex flex-column align-items-center justify-content-center my-4"
              >
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <molecule-pagination-with-per-page
        :page="filterList.currentPage"
        :total-count="filterList.totalCount"
        :per-page="filterList.perPage"
        @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
      ></molecule-pagination-with-per-page>
    </b-card>
    <footer style="padding-top: 1px"></footer>

    <molecule-modal-dialog
      :modalId="modalDelete"
      icon="AlertCircleIcon"
      :isTextCenter="true"
      :textTitle="`Do you want to delete\n${templateDelete.templateName}?`"
      textSubtitle="You won’t be able to revert this!"
      buttonTextLeft="Delete"
      buttonTextRight="Cancel"
      buttonColorLeft="danger"
      @clickButtonLeft="confirmDeleteTemplate"
    />
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive"
import { BBadge, BCard, BButton, BTable, BPagination } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismEscalationTemplate",
  components: {
    BBadge,
    BCard,
    BButton,
    BTable,
    BPagination,
    AtomButton,
    AtomInput,
    AtomMultiSelect,
    MoleculeModalDialog,
    MoleculePaginationWithPerPage,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsUser],
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterList: {
      required: true,
      type: Object,
    },
    templateStatusOption: {
      type: Array,
      required: true,
    },
  },
  emits: [
    "onDeleteTemplate",
    "onUpdateFilterData",
    "onSetDefaultFilterData",
    "onUpdateCurrentPageOrPerPage",
  ],
  data() {
    return {
      templateDelete: {},
      modalDelete: "modal-confirm-delete-escalation",
    }
  },
  computed: {
    hasUpdateTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_WRITE)
    },
    hasDeleteTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_DELETE)
    },
  },
  methods: {
    badgeVariant(status) {
      if (status.toLowerCase() === "active") return "light-success"
      return "light-secondary"
    },

    badgeStatus(status) {
      if (status.toLowerCase() === "active") return "Active"
      return "Suspended"
    },

    gotoEscalationHistory() {
      this.navigateTo("/internal/web-portal/escalation/history")
    },

    goToTicketTracking() {
      this.navigateTo("/internal/web-portal/ticket")
    },

    goToCreateTemplate() {
      this.navigateTo("/internal/web-portal/escalation/template/create")
    },

    selectRow(row) {
      const { templateId } = row
      this.navigateTo(`/internal/web-portal/escalation/${templateId}`)
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    clickButtonSearch() {
      this.filterList.currentPage = 1
      this.$emit("onUpdateFilterData", this.filterList)
    },
    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    clickDeleteTemplate(template) {
      this.templateDelete = template.item
      this.$bvModal.show(this.modalDelete)
    },

    confirmDeleteTemplate() {
      this.$emit("onDeleteTemplate", this.templateDelete)
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper ::v-deep.b-table-sticky-header {
  min-height: 500px;
  max-height: calc(100vh - 625px);
  &:has(.b-table-empty-row) {
    min-height: 350px;
  }
}

.card-padding {
  padding: 21px;
}

.card-padding-x {
  padding-left: 21px;
  padding-right: 21px;
}

.card-padding-y {
  padding-top: 21px;
  padding-bottom: 21px;
}

.card-padding-top {
  padding-top: 21px;
}

.card-padding-bottom {
  padding-bottom: 21px;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.active-menu {
  padding: 8px 21px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  background: #7367f0;
  border-radius: 5px;
  box-shadow: 0px 4px 18px -4px rgba(115, 103, 240, 0.65);
}

.menu-link {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

.custom-padding-left-10px {
  padding-left: 10px;
}

.dot {
  margin-left: 4px;
  height: 6px;
  width: 6px;
  background-color: #ea5455;
  border-radius: 50%;
  display: inline-block;
}

.custom-template-name-wrapper {
  width: 170px;
}

.custom-description-wrapper {
  width: 355px;
}
</style>
